import { myVaultModel } from '@models/myvault.model';
import { useModel } from 'foca';
import { throttle } from 'lodash-es';
import { useEffect } from 'react';
import { useAddress } from './use-address';
import { useRefreshTime } from './use-refresh';

const fetchMyVaults = throttle(myVaultModel.getMyVaults, 10, { leading: true, trailing: false });

export const useMyVaults = () => {
  const address = useAddress();
  const { refreshTime } = useRefreshTime();
  const myVaults = useModel(myVaultModel, (state) => state.myVault[address || '']);

  useEffect(() => {
    address && fetchMyVaults(address, !!refreshTime);
  }, [address, refreshTime]);

  return {
    myVaults,
  };
};

export const useMyVault = (vaultId: string) => {
  const address = useAddress();
  const myVaults = useModel(myVaultModel, (state) => state.myVault[address || '']);

  return {
    myVault: myVaults ? myVaults.find((vault) => vault.vault_id === vaultId) : undefined,
  };
};
